export const ASH_ADMIN = 'client-portal.super-administrator' as const
export const ORGANIZATION_ADMIN = 'client-portal.organization-admin' as const
export const PROGRAM_ADMIN = 'client-portal.administrator' as const
export const NON_PHI_ORGANIZATION_ADMIN = 'client-portal.non-phi-organization-admin' as const
export const NON_PHI_PROGRAM_ADMIN = 'client-portal.non-phi-program-admin' as const

export const ROLES = [
  { value: ASH_ADMIN, name: 'Ash Administrator' },
  { value: ORGANIZATION_ADMIN, name: 'Organization Administrator' },
  { value: PROGRAM_ADMIN, name: 'Program Administrator' },
  { value: NON_PHI_ORGANIZATION_ADMIN, name: 'Non-PHI Organization Administrator' },
  { value: NON_PHI_PROGRAM_ADMIN, name: 'Non-PHI Program Administrator' },
] as const

export const SELECT_CLIENT_OPTION = { clientId: 'none', name: 'Select Client' } as const

export type ClientPortalRole = (typeof ROLES)[number]['value']
